import { Entity, ISubmodelElement } from 'api/v3/aas_core_meta/types';
import { ReactNode, SyntheticEvent, useState } from 'react';
import { ChevronRight, ExpandMore } from '@mui/icons-material';
import { SubmodelElementRenderer } from '../SubmodelElementRenderer';
import { SubmodelViewObject } from 'types/SubmodelViewObject';
import { generateSubmodelViewObjectFromSubmodelElement } from 'util/SubmodelViewObjectUtil';
import { TreeView } from '@mui/x-tree-view';
import { EntityTreeItem } from './EntityTreeItem';

type EntityComponentProps = {
    readonly entity: Entity;
};

export function EntityComponent(props: EntityComponentProps) {
    const { entity } = props;
    const [expandedTreeItems, setExpandedTreeItems] = useState<string[]>(['0']);
    const componentList: ReactNode[] = [];
    const entityTree: SubmodelViewObject = generateSubmodelViewObjectFromSubmodelElement(entity, '0');

    entity?.statements?.forEach((val, index) => {
        componentList.push(<SubmodelElementRenderer key={index} submodelElement={val} hasDivider={!(index === 0)} />);
    });

    const handleToggle = (event: SyntheticEvent, nodeIds: string[]) => {
        setExpandedTreeItems(nodeIds);
    };

    const renderTree = (tree: SubmodelViewObject) => {
        return (
            <EntityTreeItem key={tree.id} nodeId={tree.id} label={tree.name} data={tree.data as ISubmodelElement}>
                {tree.children.length ? tree.children.map((childTree) => renderTree(childTree)) : undefined}
            </EntityTreeItem>
        );
    };

    return (
        <TreeView
            defaultCollapseIcon={<ExpandMore />}
            defaultExpandIcon={<ChevronRight />}
            expanded={expandedTreeItems}
            onNodeToggle={handleToggle}
            disableSelection
        >
            {renderTree(entityTree)}
        </TreeView>
    );
}
